import React from "react";
import PropTypes from "prop-types";
import styles from "./OrderOptionsCard.module.css";

const optionMeta = [
  { key: "markAsWWG", label: "Mark as WWG Order" },
  { key: "priorityShipping", label: "Priority Shipping" },
  { key: "chargeCardOnFile", label: "Charge Card On File" },
];

export function OrderOptionsCard({
  options = {},
  onChange = () => {},
  title = "Order Options",
  disabledKeys = [],
  hints = {},
}) {
  const disabledSet = React.useMemo(
    () => new Set(disabledKeys),
    [disabledKeys]
  );

  const handleToggle = (key, value) => () => {
    onChange(key, value);
  };

  return (
    <div className={styles.card}>
      {title && <p className={styles.title}>{title}</p>}
      <div className={styles.optionList}>
        {optionMeta.map(({ key, label }) => {
          const currentValue = Boolean(options[key]);
          const isDisabled = disabledSet.has(key);
          const hint = hints[key];
          return (
            <div className={styles.optionItem} key={key}>
              <div className={styles.optionRow}>
                <span className={styles.optionLabel}>{label}</span>
                <div className={styles.toggleGroup}>
                  <button
                    type="button"
                    disabled={isDisabled}
                    aria-label={`${label}: Yes`}
                    title={`Turn on "${label}" for this order.`}
                    aria-pressed={currentValue}
                    className={`${styles.toggleBtn} ${
                      currentValue ? styles.selected : ""
                    } ${isDisabled ? styles.toggleBtnDisabled : ""}`}
                    onClick={isDisabled ? undefined : handleToggle(key, true)}
                  >
                    <span
                      className={`${styles.indicator} ${
                        currentValue ? styles.indicatorSelected : ""
                      }`}
                    />
                    <span className={styles.labelText}>Yes</span>
                  </button>
                  <button
                    type="button"
                    disabled={isDisabled}
                    aria-label={`${label}: No`}
                    title={`Turn off "${label}" for this order.`}
                    aria-pressed={!currentValue}
                    className={`${styles.toggleBtn} ${
                      !currentValue ? styles.selected : ""
                    } ${isDisabled ? styles.toggleBtnDisabled : ""}`}
                    onClick={isDisabled ? undefined : handleToggle(key, false)}
                  >
                    <span
                      className={`${styles.indicator} ${
                        !currentValue ? styles.indicatorSelected : ""
                      }`}
                    />
                    <span className={styles.labelText}>No</span>
                  </button>
                </div>
              </div>
              {hint && <p className={styles.optionHint}>{hint}</p>}
            </div>
          );
        })}
      </div>
    </div>
  );
}

OrderOptionsCard.propTypes = {
  options: PropTypes.shape({
    markAsWWG: PropTypes.bool,
    priorityShipping: PropTypes.bool,
    chargeCardOnFile: PropTypes.bool,
  }),
  onChange: PropTypes.func,
  title: PropTypes.string,
  disabledKeys: PropTypes.arrayOf(PropTypes.string),
  // eslint-disable-next-line react/forbid-prop-types
  hints: PropTypes.object,
};
